import Element, { ElementType, SpecyficType } from '../element';
import store from '@/store';
import { util } from '../util';
import { BaseCommand } from './baseCommand';
import { HandleWallSupportsCommand } from './handleWallSupportsCommand';
import { AddWallsCommand } from './addWallsCommand';
import { HandleBacksCommand } from './handleBacksCommand';
import { HandleLegsSupportCommand } from './handleLegsSupportCommand';

export default class RemoveElementCommand extends BaseCommand {

    constructor(
        elements: Element[],
        private elementsToDelete: Element[],
        scenePreview: any,
    ) {
        super(scenePreview);
        this.elements = elements;
    }

    public execute(): void {
        const selectedElements = this.elementsToDelete;
        const bindings = util.flatMap(selectedElements, (x) => x.bindings);
        selectedElements.push(...bindings);
        selectedElements.forEach((x) => x.isVisible = false);

        const filteredElements = this.elements.filter((x) => !selectedElements.includes(x));
        this.elements.splice(0, this.elements.length);
        this.elements.push(...filteredElements);

        store.dispatch('sapCalculate');

        this.addCommand(new HandleWallSupportsCommand(this.scenePreview));

        this.elementsToDelete.filter((x) => { // dodawanie przegrody między szufladami. 
            return (
                x.type === ElementType.FRONT &&
                x.bindings.some((binding) => binding.specyficType === SpecyficType.DRAWER)
            );
        }).forEach((x) => this.addCommand(new AddWallsCommand(x, this.scenePreview)));

        if (selectedElements.some((x) => x.specyficType === SpecyficType.VERTICAL_WALL)) {
            const handleBacksCommand = new HandleBacksCommand(this.scenePreview);
            this.addCommand(handleBacksCommand);
        }

        this.addCommand(new HandleLegsSupportCommand(this.scenePreview));
    }

    public revert(): void {
        this.elements.push(...this.elementsToDelete);
        this.revertCommands();
        this.elementsToDelete.forEach((x) => {
            x.isVisible = true;
            if (x.type === ElementType.FRONT ||
                x.type === ElementType.HANDLE) {
                x.isVisible = store.getters.scene.areFrontsVisible;
            }
        });
    }
}
